import { createReducer, on } from '@ngrx/store';
import { Doubt } from 'src/app/models/doubt.model';
import * as fromDoubtsActions from '../actions/doubts.actions';

export interface DoubtsState {
  data: Doubt[];
  loaded: boolean;
  loading: boolean;
  error: string;
  selectedDoubtId: string;
}

export const initialState: DoubtsState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: '',
  selectedDoubtId: ''
};

export const doubtsReducer = createReducer(
  initialState,
  on(fromDoubtsActions.LoadDoubtsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromDoubtsActions.LoadDoubtsSuccessAction, (state, { data }) => ({
    ...state,
    data,
    loaded: true,
    loading: false
  })),
  on(fromDoubtsActions.LoadDoubtsFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromDoubtsActions.AddComentAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromDoubtsActions.AddComentSuccessAction, (state, { comment, doubt }) => ({
    ...state,
    data: state.data.map((doubtData) => {
      let doubtToReturn = { ...doubtData };
      if (doubtData.id === doubt.id) {
        doubtToReturn.comments = [
          ...(doubtToReturn.comments || []),
          { ...comment, date: new Date(comment.date) }
        ];
      }
      return doubtToReturn;
    }),
    loaded: true,
    loading: false
  })),
  on(fromDoubtsActions.AddComentFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromDoubtsActions.SelectDoubtAction, (state, { doubtId }) => ({
    ...state,
    selectedDoubtId: doubtId
  })),
  on(fromDoubtsActions.UnselectDoubtAction, (state) => ({
    ...state,
    selectedDoubtId: ''
  }))
);
